import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import StandardModal from 'components/shared/StandardModal';
import LocationEpisode from 'models/LocationEpisode';
import Profile from 'models/Profile';
import { extractSupplementalEpisodeInformation } from 'services/api/portfolio';
import { colors } from 'styles/theme/colors';
import { BodySmall, BodySmallBold } from 'styles/typography';

import { PatientCard } from './PortfolioCard';

type SharedRecordSelectionModalProps = {
  records: LocationEpisode[];
  profile: Profile;
  onClose: () => void;
};

export default function SharedRecordSelectionModal({ records, profile, onClose }: SharedRecordSelectionModalProps) {
  const navigate = useNavigate();

  const handleSelect = (record: LocationEpisode) => {
    onClose();
    navigate(`/patients/${record.episodeId}?locationEpisodeId=${record.id}`);
  };

  return (
    <StandardModal title='Select Patient Record' onCancel={onClose} closeOnBackdropClick>
      <Prompt>
        <BodySmallBold as='span'>This patient is linked to {records.length} records in Olio.</BodySmallBold> View
        associated details for each record and know what team in Olio is receiving updates.
      </Prompt>
      <RecordList>
        {records.map((record) => (
          <RecordRow key={record.id} onClick={() => handleSelect(record)}>
            <PatientCard
              locationEpisode={record}
              info={extractSupplementalEpisodeInformation(record as any)}
              profile={profile}
              invalidateColumn={() => {}}
            />
          </RecordRow>
        ))}
      </RecordList>
    </StandardModal>
  );
}

const Prompt = styled(BodySmall)`
  color: ${colors.black75};
  margin-bottom: 24px;
`;

const RecordList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const RecordRow = styled.div`
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid ${colors.black10};
  overflow: hidden;
  transition: border-color 0.15s ease;

  &:hover {
    border-color: ${colors.primaryBlue};
  }
`;
